import React,{useState,useEffect} from 'react'
import Button from '../../../Components/commonButton/commonButton'
import TextField from '../../../Components/textField/textField'
import Api from '../../../services/api'
import Alert from '../../../Components/alert/Alert'
import Select from "../../../Components/select/select";
import Notification from "../../../Components/notification/Notification";
import Loading from "../../../Components/loadingNotification/loadingNotification";
import '../general.css';

const AddEmployee =() => {
  const [show,setShow] = useState(false);
  const [name,setName] = useState("");
  const [shifts,setShifts] = useState([{value:0,label:"Turno 0"}]);
  const [shiftId,setShiftId] = useState("");
  const [employee_code,setEmployee_code] = useState("");
  const [message,setMessage] = useState("");
  const [reload,setReload] = useState(false);
  const [notification, setNotification] = useState(false);
  const [notification_type, setNotificationType] = useState("success");
  const [notification_message, setNotificationMessage] = useState("");
  
  useEffect(()=>{
    Api.get('/work-shifts/').then(({status,data})=>{
      if(status === 200){
        let auxarr = []
        data.forEach(({id,code}) => {
          auxarr.push({value:id,label:code})
        });
        setShifts([...auxarr])
      }
    }).catch((err)=>{
      console.log(err)
    })
  },[])

  const sendData = () => {
    if ((name !== "" && name !== null) && (employee_code !== "" && employee_code !== null) && (shiftId !== "" && shiftId !== null)) {
      Api.post('/employees/',[{
        name: name.toUpperCase(),
        code:employee_code,
        id_work_shift:shiftId,
        is_active:true
      }]).then((res) => {
      
        setNotification(true);
          setNotificationType("success");
          setNotificationMessage("Funcionário cadastrado com sucesso!");
          setTimeout(()=>{
            return window.location.reload();
          },2000)
      }).catch(err=>{
        setMessage(""+err.message)
        setShow(true)
      })

     
    } else {
      setMessage("Necessário preencher todos os campos.")
      setShow(true)
    }
  }

  const handleSelect = (element) => {
    const {value} = shifts.find(
      (v) => v.value == element
    );
    setShiftId(value)
  };

  const callbackfunction = () => { setShow(false) }

    return (
      <div className='box'>
        {notification == true ? (<><Notification message={notification_message} type={notification_type}></Notification><Loading></Loading></>) : (<></>)}
        <div className="input_fields_add_employee form">
        <h4>Adicionar Funcionário</h4>
          <div className='inputs'>
              {show ? <Alert show={show} message={message} parentCallback={callbackfunction} reload={reload} /> : null}
              <div className='element'><TextField section={false} focus={true} validationType="varchar" value={name} title="Nome Completo" max={60} parentCallback={setName} /></div>
              <div className='element'><TextField section={true} title="Crachá" validationType="int" value={employee_code} min={3} max={10} parentCallback={setEmployee_code} /></div>
              <div className='element'><Select autoSelect={false} label="Turno" handleSelect={handleSelect} arrData={shifts} /></div>
            </div>
            <div className='submitButton'><Button icon="add" title="Adicionar" parentCallback={sendData}/></div>
        </div>
      </div>
    );
}

export default AddEmployee